import React from 'react';
import { NavLink as ReactRouterLink, useLocation } from 'react-router-dom';
import { StarTwoTone } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

/**
 * @param {Object} props
 * @param {string} props.text
 * @param {string} props.path
 * @param {string} [props.group=null]
 * @param {string} [props.groupHead=null]
 */
export function SideNavLink(props) {
  const {
    text,
    path,
    group,
    groupHead,
  } = props;

  const { pathname: currentPath } = useLocation();

  // Prefix match, so detail pages (`/tenant/view/218700`) highlight their item. The
  // trailing slash stops `/tenant/view` claiming `/tenant/viewsomething`.
  const isActive = () => {
    if (groupHead) {
      return false;
    }

    return currentPath === path || currentPath.startsWith(`${path}/`);
  };

  if (group && !currentPath.startsWith(group)) return null;
  return (
    <Grid size={12} sx={{ marginLeft: (theme) => theme.spacing(group ? 3 : 0) }}>
      <Link
        color="textSecondary"
        isActive={isActive}
        component={ReactRouterLink}
        to={path}
        className="side-item"
        underline="none"
      >
        {text}
      </Link>
    </Grid>
  );
}

/**
 * @param {Object} props
 * @param {string} props.text
 * @param {string} props.path
 * @param {boolean} [props.favorited=false]
 */
export function InsetNavLink(props) {
  const {
    text,
    path,
    favorited,
  } = props;

  return (
    <Link
      className="side-item inset-nav-link"
      color="textSecondary"
      component={ReactRouterLink}
      to={path}
      underline="none"
    >
      <Stack direction="row" sx={{ alignContent: 'start' }}>
        <StarTwoTone
          sx={{
            visibility: favorited ? 'show' : 'hidden',
            height: favorited ? '100%' : 0,
          }}
          className="star-selected"
        />
        <Typography>{text}</Typography>
      </Stack>
    </Link>
  );
}
